export const BASIS_LABEL = { "558": "Vergleichsmiete/Vereinbarung", "559": "Modernisierung (§ 559)", "557a": "Staffel (§ 557a)", "557b": "Index (§ 557b)" };

const CLS = {
  possible_now: "bg-emerald-50 text-emerald-800 border-emerald-200",
  possible_from: "bg-amber-50 text-amber-800 border-amber-200",
  no_data: "bg-slate-100 text-slate-700 border-slate-200",
  no_potential: "bg-slate-50 text-slate-500 border-slate-200",
  excluded: "bg-rose-50 text-rose-700 border-rose-200",
  error: "bg-rose-50 text-rose-700 border-rose-200",
};

export function StatusPill({ status, label, testId }) {
  return <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-medium ${CLS[status] || CLS.no_data}`} data-testid={testId || "ri-status"}>{label}</span>;
}
